var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgPowershell = function SvgPowershell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f77c7",
    d: "M17.358 2.93H4.341c-.406 0-.81.331-.904.739L.825 15.082c-.093.408.16.739.565.739h13.017c.406 0 .81-.331.903-.739l2.612-11.413c.093-.408-.16-.739-.565-.739z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.399 12.826h3.166c.368 0 .667.311.667.695s-.298.695-.667.695H9.399c-.368 0-.667-.311-.667-.695s.298-.695.667-.695zM11.453 9.735c-.054.11-.168.231-.368.371l-5.876 4.22c-.321.233-.781.147-1.028-.193s-.187-.804.133-1.037l5.299-3.837V9.18L6.284 5.638c-.272-.289-.243-.756.063-1.044s.775-.286 1.046.003l3.995 4.25a.724.724 0 0 1 .065.888z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPowershell);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;